/* eslint-disable @typescript-eslint/no-unused-vars */
import {
  ICreateEngineFiscalRulesState,
  IEngineFiscalRulesState,
  IEngineFiscalRulesStateParams,
} from "@/@types/engine-fiscal-rules";
import { Paginated } from "@/@types/paginated";
import { Tags } from "@/enum/tags";
import { apiSlice } from "./http";

export const engineFiscalRulesService = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getEngineFiscalRules: builder.query<
      Paginated<IEngineFiscalRulesState>,
      IEngineFiscalRulesStateParams
    >({
      query: ({ meta, state, tip, final_term, initial_term, created_at }) => {
        const paramsObj: Record<string, string | undefined> = {
          state,
          tip,
          final_term,
          initial_term,
          page: meta.page?.toString(),
          perPage: meta.perPage?.toString(),
          created_at,
        };

        const params = new URLSearchParams(
          Object.entries(paramsObj)
            .filter(([_, value]) => value !== undefined && value !== '')
            .reduce(
              (acc, [key, value]) => ({ ...acc, [key]: value as string }),
              {}
            )
        );

        return {
          url: `/engine-fiscal/rules?${params.toString()}`,
          method: "GET",
        };
      },
      providesTags: [Tags.ENGINE_FISCAL_RULES],
    }),
    createEngineFiscalRules: builder.mutation<
      void,
      ICreateEngineFiscalRulesState[]
    >({
      query: (body) => ({
        url: `/engine-fiscal/rules`,
        method: "POST",
        body,
      }),
      invalidatesTags: [Tags.ENGINE_FISCAL_RULES],
    }),
  }),
});

export const {
  useGetEngineFiscalRulesQuery,
  useCreateEngineFiscalRulesMutation,
} = engineFiscalRulesService;

export const {
  endpoints: { getEngineFiscalRules, createEngineFiscalRules },
} = engineFiscalRulesService;
